import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    Setting,
    TibboDataType,
    SettingType,
} from '@appblocks/codegeneration/types';
import { generateId } from '@appblocks/utils';
import Tibbits from '@appblocks/codegeneration/Tibbits/index';
import FeatureUtils from '@appblocks/codegeneration/FeatureUtils';

export default class Tibbit63Node extends BaseNode {
    constructor() {
        super();
        this.name = 'Tibbit 63';
        this.id = 'node_tibbit_63';
        this.linkedFeature = 'tibbit_63';

        this.inputs = [
            {
                name: 'Get Line',
                portId: 'get_line',
                params: [],
            },
        ];

        this.outputs = [
            {
                name: 'Line State',
                portId: 'lineState',
                params: [
                    {
                        name: 'state',
                        dataType: TibboDataType.BYTE,
                    },
                ],
            },
        ];
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;
        const featureID = this.getSettingValue('TIBBIT');
        const tibbit = project.getFeature(featureID);
        if (!tibbit) {
            return blocks;
        }
        const socketNumber = tibbit.getSettingValue('SOCKET');
        const lineName = tibbit.getSettingValue('NAME').concat('_L4');
        const useInterrupt = tibbit.getSettingValue('INTERRUPT');
        const interruptNumber = Tibbits.getSocket(socketNumber, this.project.device.id)?.interrupt;
        const interruptValue = PlatformUtils.getEnumValue(interruptNumber, 'pl_int_num', this.project.device.platform);
        const interruptBit = Math.pow(2, Number(interruptValue));
        const lineStateLocation = `${lineName}_get_state`;
        const interruptEnum = PlatformUtils.getEnum(interruptNumber, 'pl_int_num', this.project.device.platform);

        if ((interruptEnum !== null) && (useInterrupt === '1')) {
            blocks.push({
                location: 'on_io_int',
                blockType: BlockType.CODE,
                template: `
    if (linestate and ${interruptBit}) <> 0 then
        'interrupt has been triggered by Tibbit 63 on socket ${socketNumber}
        ${lineStateLocation}(io.lineget(${lineName}))
    end if
`,
            });
        }

        blocks.push({
            location: 'DEVICE_TBS',
            blockType: BlockType.CODE,
            id: generateId(),
            template: ` 
sub ${lineStateLocation}(state as low_high)
    '****${lineStateLocation}****'
end sub
            `,
        });

        blocks.push({
            location: 'GLOBAL_DECLARATIONS',
            blockType: BlockType.CODE,
            template: `
declare sub ${lineStateLocation}(state as low_high)`,
        });

        let links = project.getNodeLinks(this, 'lineState');
        if (links.length > 0) {
            const link = links[0];
            blocks.push({
                location: `${lineStateLocation}`,
                blockType: BlockType.CODE,
                template: `'****${link.getSourceId()}****'`,
            });
        }

        links = project.getNodeLinks(this, 'get_line');
        for (let i = 0; i < links.length; i += 1) {
            const link = links[i];
            blocks.push({
                location: link.getSourceId(),
                blockType: BlockType.CODE,
                id: link.getID(),
                template: `    ${lineStateLocation}(io.lineget(${lineName}))`,
            });
        }
        return blocks;
    }
}
